import React from "react";
import cookie from 'react-cookies'
import {connect} from "react-redux";


class UserInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        } 
    }

    render() {
        
        return (
            <ul className="setting-box">
                <li>
                    <span>이름</span>
                    <span>{this.props.userName}</span>
                </li>
                <li>
                    <span>계정</span>
                    <span>{cookie.load('username')}</span>
                </li>
            </ul>
        )
    }
}

function mapStateToProps(state) {
    return {
        accessToken: state.hejhome.accessToken, 
        userName: state.hejhome.userName, 
    }
}


// dispatch - set
const mapDispatchToProps = dispatch => ({
    setAccessToken: (token) => dispatch({
        type: 'setAccessToken',
        accessToken: token,
    }),
});

UserInfo = connect(mapStateToProps, mapDispatchToProps)(UserInfo);


export default UserInfo;

